import classNames from 'classnames';
import { isEmpty } from 'lodash';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

import { PintoProductCampaignUserType } from '../../../core/graphql/types';
import { IWriterRegisterCampaignFields, WRITER_REGISTER_CAMPAIGN_FIELD_KEYS } from '../validates/writerRegisterCampaignSchema';

const USER_TYPE_OPTIONS = [
  { label: 'UGC', value: PintoProductCampaignUserType.Ugc },
  { label: 'PGC', value: PintoProductCampaignUserType.Pgc, disabled: true },
];

interface IPropsUserTypeSelector {
  disabled?: boolean;
}

const UserTypeSelector = (props: IPropsUserTypeSelector) => {
  const { disabled } = props;
  const {
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();

  const [userType] = watch([WRITER_REGISTER_CAMPAIGN_FIELD_KEYS.USER_TYPE]);

  const onClickUserType = useCallback(
    (value: string) => {
      setValue(WRITER_REGISTER_CAMPAIGN_FIELD_KEYS.USER_TYPE as IWriterRegisterCampaignFields, value);
    },
    [setValue],
  );

  return (
    <section className="flex flex-col">
      <label className="label">
        <span
          className={classNames('label-text text-systemGrays02LabelSecondary', {
            'text-colorsBrandRed01Primary': !userType && !isEmpty(errors.userType?.message),
          })}
        >
          ประเภทผู้ใช้ <span className="text-colorsBrandRed01Primary">*</span>
        </span>
      </label>
      <select
        className={classNames('select select-bordered min-w-[240px]', {
          'select-error': !userType && !isEmpty(errors.userType?.message),
        })}
        value={(userType as string) || ''}
        onChange={(e) => onClickUserType(e.target.value)}
        disabled={disabled}
      >
        {USER_TYPE_OPTIONS.map((option) => (
          <option key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
      </select>
      {!userType && !isEmpty(errors.userType?.message) && (
        <label className="pt-4 label">
          <span className="label-text-alt font-tt text-colorsBrandRed01Primary">{errors.userType?.message as string}</span>
        </label>
      )}
    </section>
  );
};

export default UserTypeSelector;
